export class JourneyLocation {

  public static OnFilterApplied(transportLocation: InterACT.Interfaces.Journeys.TransportLocation) {
    switch (transportLocation.locationType) {
      case 'NAPTAN':
        return JourneyLocation.extractNaptanLocation(transportLocation.locationFields);
      case 'BUS_FARE_STAGE':
        return transportLocation.locationFields.stage;
      default:
        return 'Unknown Location';
    }
  }

  private static extractNaptanLocation(locationFields: any) {
    //Note this is for demo purposes only since Naptan locations should be including friendly names
    switch (locationFields.BUS_STOP_CODE) {
      case '69345274':
        return 'Bonn Square stop D4';
      case '69345729':
        return 'Queens Lane stop K2';
      case '69323535':
        return 'The Plain';
      case '69323254':
        return 'James Street West';
      case '69323262':
        return 'Henley Street';
      case '69323253':
        return 'Magdalen Road West';
      default:
        return locationFields.BUS_STOP_CODE;
    }
  }

}
